<template>
  <div>
    <template v-if="userHasAccess">
      <template v-if="allDataLoaded && !loadError">
        <f-tabs :items="tabItems" small>
          <div slot="tab-0">
            <communication-email-form
              v-if="allDataLoaded"
              :adviser="adviser"
              :allAvailableCustomers="customersAvailableForContact" />
          </div>
          <div slot="tab-1">
            <communication-sms-form
              v-if="allDataLoaded"
              :adviser="adviser"
              :allAvailableCustomers="customersAvailableForContact" />
          </div>
        </f-tabs>
      </template>
      <template v-else>
        <div
          v-if="!allDataLoaded && !loadError && userHasAccess"
          class="loading-spinner-wrapper">
          <div class="loading-spinner pb-3 pt-3">
            <span class="loading-spinner-content">
              {{ $t('ui.loadingDataInProgress') }}&hellip;
            </span>
          </div>
        </div>
        <div class="wrapper mt-3">
          <f-alert
            v-if="loadError"
            theme="warning"
            visible>
            <span>
              {{ $t('ui.dataLoadError.dataErrorMess') }} <a href="javascript:window.location.reload();" class="lnk lnk-alert">{{ $t('ui.dataLoadError.resetPageButton') }}</a> {{ $t('ui.dataLoadError.forTryAgain') }}
            </span>
          </f-alert>
        </div>
      </template>
    </template>
    <div
      v-else
      class="wrapper pt-3 pb-1">
      <f-alert
        visible
        class="my-2"
        theme="inactive">
        <span>
        {{ $t('user.currentPackageDoesNotIncludeAccessToSection') }}
        </span>
      </f-alert>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import FormUtils from '@/utils/FormUtils.js';
import Pagination from '@/components/core/Pagination.vue';
import HasPagination from '@/mixins/HasPagination.vue';
import CommunicationEmailForm from '@/views/forms/communication/CommunicationEmailForm.vue';
import CommunicationSMSForm from '@/views/forms/communication/CommunicationSMSForm.vue';

export default {
  name: 'communication',
  mixins: [
    HasPagination
  ],
  components: {
    'pagination': Pagination,
    'communication-email-form': CommunicationEmailForm,
    'communication-sms-form': CommunicationSMSForm
  },
  computed: {
    allDataLoaded () {
      return this.customersLoaded && this.adviserLoaded;
    },
    customersAvailableForContact () {
      return this.allCustomers.filter(item => item.contact_finhub_agreement);
    },
    userHasAccess () {
      return this.$store.getters.getUserHasFeature('communications');
    }
  },
  watch: {
    userHasAccess (newValue) {
      if (newValue && !this.viewInitiated) {
        this.loadAdditionalData();
      }
    }
  },
  data () {
    return {
      adviser: null,
      adviserLoaded: false,
      allCustomers: [],
      customersLoaded: false,
      loaded: false,
      loadError: false,
      tabItems: [{
        title: this.$t('communication.messageEmail')
      }, {
        title: this.$t('communication.messageSMS')
      }],
      viewInitiated: false
    };
  },
  mounted () {
    if (this.userHasAccess) {
      this.loadAdditionalData();
    }
  },
  methods: {
    loadAdditionalData () {
      Vue.set(this, 'viewInitiated', true);

      FormUtils.loadAdditionalData(this, {
        endpoint: '/api/adviser/customers/items',
        method: 'get',
        outputKey: 'allCustomers',
        loadedKey: 'customersLoaded',
        errorKey: 'loadError',
        params: {
          where: { status: 'INVITATION_CONFIRMED' },
          pagination: 0
        }
      });

      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/api/adviser/adviser/item',
        loadedKey: 'adviserLoaded',
        outputKey: 'adviser',
        pagination: false
      });
    }
  }
};
</script>
